<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<cytomine-modal-card :title="$t('about-samantree')" @close="$parent.close()">
  <template>
    <div class="samantree-logo">
      <a :href="website" target="_blank">
        <img :src="logo" class="sponsor">
      </a>
    </div>
    <dl>
      <dt>{{$t('version')}}</dt>
      <dd>{{version || '?'}}</dd>

      <dt>{{$t('description')}}</dt>
      <dd>
        <i18n :path="'samantree-sponsors-info'">
          {{'samantree-company'}}
        </i18n>
      </dd>

      <dt>{{$t('website')}}</dt>
      <dd>
        <i18n path="samantree-website-info">
          <a place="websiteLink" :href="website" target="_blank">samantree.com</a>
        </i18n>
      </dd>

      <!-- Disabled until we review the product features
      <dt>{{$t('documentation')}}</dt>
      <dd>
        <i18n path="documentation-info">
          <a place="docLink" href="https://doc.cytomine.com/" target="_blank">{{$t('here')}}</a>
        </i18n>
      </dd>
      -->

      <dt>{{$t('disclaimer')}}</dt>
      <dd>{{$t('samantree-disclaimer')}}</dd>

      <dt>{{$t('ownership')}}</dt>
      <dd>{{$t('samantree-ownership')}}</dd>

      <dt>{{$t('contact')}}</dt>
      <dd>
        <i18n path="contact-info">
          <a place="contactMail" :href="`mailto:${contact}`">{{contact}}</a>
        </i18n>
      </dd>
    </dl>
  </template>
</cytomine-modal-card>
</template>

<script>
import constants from '@/utils/constants.js';
import CytomineModalCard from '@/components/utils/CytomineModalCard';

export default {
  name: 'about-samantree-wrapper',
  components: {CytomineModalCard},
  data() {
    return {
      version: constants.HLC_VERSION,
      website: constants.SAMANTREE_WEBSITE,
      contact: constants.SAMANTREE_CONTACT_EMAIL,
      logo: require('@/assets/sponsors/logo-samantree-full.svg'),
    };
  },
  computed: {
    editionLabelSuffix() {
      return "-eet"; //TODO
    }
  }
};
</script>

<style scoped>
.modal-card, .modal-card-body {
  width: 50vw;
  min-width: 700px;
  font-weight: normal;
}

dt {
  float: left;
  width: 12rem;
  text-align: right;
  padding-right: 1rem;
  clear: both;
  font-weight: 600;
}

dd {
  margin-left: 14rem;
  background-color: #fff;
  margin-bottom: 0.75rem;
}

img.sponsor {
  height: 5rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}

.samantree-logo {
  display: flex;
  justify-content: center;
}
</style>
